<template>
  <div :class="$style.container">
    <LoadingOverlay :showLoadingOverlay="loading" />
    <NoRecordsFound v-show="!loading && !totalCount" />
    <TableWithPagination
      v-show="totalCount"
      :columns="columns"
      :currentPageNum="currentPageNum"
      :footerDetails="footerDetails"
      :inCard="false"
      :rowsPerPage="rowsPerPage"
      :tableData="tableData"
      :totalCount="totalCount"
      @pageChange="handlePageChange"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import LoadingOverlay from 'components/LoadingOverlay/LoadingOverlay.vue';
import NoRecordsFound from 'client/components/Tables/NoRecordsFound.vue';
import SystemInsightsMetadata from 'client/systems/systemInsights/SystemInsightsMetadata';
import TableWithPagination from 'components/Tables/TableWithPagination.vue';

const { metricGroupMetadata } = SystemInsightsMetadata;
const systemInsightsModule = StoreModuleMap[ItemTypeConsts.systemInsights];

export default {
  name: 'InsightsMultiItemTable',

  components: {
    NoRecordsFound,
    LoadingOverlay,
    TableWithPagination,
  },

  props: {
    exportEnabled: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Array,
      default: () => [],
    },
    metricGroup: {
      type: String,
      default: '',
    },
    systemId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    currentPageNum: 0,
    loading: false,
    rowsPerPage: 10,
    tableData: [],
  }),

  computed: {
    ...mapGetters(systemInsightsModule, [
      'getMetricGroupTotalCount',
    ]),

    columns() {
      return metricGroupMetadata[this.metricGroup].columns;
    },

    footerDetails() {
      if (this.exportEnabled) {
        return ` ${this.label.toLowerCase()} (export to see all rows and columns)`;
      }
      return ` ${this.label.toLowerCase()}`;
    },

    label() {
      return metricGroupMetadata[this.metricGroup].label;
    },

    totalCount() {
      return this.getMetricGroupTotalCount(this.metricGroup);
    },
  },

  watch: {
    metricGroup() {
      this.currentPageNum = 0;
      this.refreshData();
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    ...mapActions(systemInsightsModule, [
      'fetchInsightsData',
    ]),

    handlePageChange(paginationData) {
      this.currentPageNum = paginationData.currentPageNum;
      this.rowsPerPage = paginationData.rowsPerPage;
      this.refreshData();
    },

    async refreshData() {
      this.loading = true;

      const params = {
        limit: this.rowsPerPage,
        skip: this.currentPageNum * this.rowsPerPage,
        filter: this.filter,
      };

      try {
        const res = await this.fetchInsightsData({
          id: this.systemId,
          metricGroup: this.metricGroup,
          params,
        });
        this.tableData = res;
      } catch (err) {
        this.tableData = [];
      }
      this.loading = false;
      this.$emit('loaded');
    },
  },
};
</script>

<style module>
.container {
  font-size: 12px;
  margin-top: 15px;
}
</style>
